import React from "react";
import serviceApi from "../assets/serviceApi.png";
import { useNavigate } from "react-router-dom";
const ServiceApi = () => {
  const navigate = useNavigate();
  const plans = [
    {
      title: "Monthly",
      price: "₹ 12,999",
      features: [
        "Completely Automated",
        "Trade Indices",
        "1 Research Indicator",
        "WhatsApp & Call Support",
        "Remote Support",
        "₹ 1,500 Maintenance Charge per Month",
      ],
    },
    {
      title: "Quarterly",
      price: "₹ 33,999",
      features: [
        "Completely Automated",
        "Trade Indices",
        "3 Research Indicator",
        "WhatsApp & Call Support",
        "Remote Support",
        "₹ 1,500 Maintenance Charge per Month",
      ],
    },
    {
      title: "Half Yearly",
      price: "₹ 51,000",
      features: [
        "Completely Automated",
        "Trade Indices",
        "5-6 Research Indicator",
        "WhatsApp & Call Support",
        "Dedicated Relationship Manager",
        "Remote Support",
        "₹ 1,500 Maintenance Charge per Month",
      ],
    },
    {
      title: "Equity Commodity Combo - Half Yearly",
      price: "₹ 71,000",
      features: [
        "Completely Automated",
        "Trade Indices",
        "7-8 Research Indicator For Equity & Commodity",
        "WhatsApp & Call Support",
        "Dedicated Relationship Manager",
        "Remote Support",
        "₹ 1,500 Maintenance Charge per Month",
      ],
    },
  ];

  return (
    <div className="px-4 bg-white text-black py-10 shadow-2xl border">
      <div className="">
        <p className="text-xl lg:text-center text-left font-bold">
          Equity Research Mart API bridge Service{" "}
        </p>
      </div>
      <div className="mx-auto my-12  w-full lg:flex px-auto gap-4 ">
        <div className="lg:w-1/2 lg:px-10 ">
          <p className="font-semibold">
            Description for Our Services 'API Bridge'
          </p>
          <p className="my-5 lg:text-left text-justify">
            In the ever-evolving landscape of technology and software
            applications, the need for seamless communication and data exchange
            between different systems has become paramount. This is where an API
            bridge comes into play. An API bridge serves as a virtual connection
            that enables two or more distinct software applications to interact
            and share information in real-time. This is applied for all kind of
            service which is provided by research analyst we are completely
            research Analyst Company which provides research calls only. We
            provide only one more facility to our customer they can use this
            facility for API bridge configuration in penal they have two option
            to run this advantage one is manual and another is automatic. In
            this facility customer can set their quantity as per their
            investment customer may set their quantity and many more facility;
            we do not have any strategy in this platform these calls given by
            only research analyst as per market situation. We provide API bridge
            facility in each of service provided like Option, Cash, Future and
            MCX
          </p>
        </div>
        <div className="flex lg:w-1/2 lg:border-s lg:shadow-lg shadow-xl border">
          <img src={serviceApi} alt="" className="lg:h-auto h-60" />
        </div>
      </div>
      <div className="">
      <div className="grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-1 gap-6 mt-14 h-full">
        {plans.map((plan, index) => (
          <div
            key={index}
            className="border border-gray-300 shadow-lg p-4 rounded-lg bg-white"
          >
            <div className="h-[80%]">
            <h3 className="text-sm font-bold text-white p-4 bg-[#2db928] ">
              {plan.title}
            </h3>
            <p className="text-lg font-bold text-blue-600 mt-2">{plan.price}</p>
            <ul className="mt-4 space-y-2 text-gray-700">
              {plan.features.map((feature, i) => (
                <li key={i} className="flex items-center">
                  ✅ {feature}
                </li>
              ))}
            </ul>
            </div>
            
            <div className=" px-4 text-start inline-block align-bottom my-5 py-4 h-[15%]" >
              <button
                onClick={() => navigate(`/equity-package-payment`)}
                className="bg-[#2db928] px-4 lg:py-1 rounded-full text-sm text-white font-medium transition-all duration-300 hover:bg-[#2db928]/80 py-2"
              >
                Pay Now
              </button>
            </div>
          </div>
        ))}
      </div>
      </div>
    </div>
  );
};

export default ServiceApi;
